import { useEffect } from 'react';
import type { Nullable } from 'corgi-types';

import { EventBusEvent } from '../../../enums/EventBus';
import eventBus from '../../../event-bus/EventBus';

const useEmitCheckoutErrorMessage = (message: Nullable<string>) =>
  useEffect(() => eventBus.emit(EventBusEvent.OnCheckoutErrorMessage, message), [message]);

export default useEmitCheckoutErrorMessage;
